export default {
    items: [{
            name: 'Dashboard',
            url: '/dashboard',
            icon: 'fa fa-dashboard',
            // badge: {
            //   variant:'success',
            //   text: 'NEW'
            // }
        },
        {
            name: 'Mutual Funds',
            url: '/mutual-funds',
            icon: 'fa fa-money',
            badge: {
                variant: 'Mutual Funds',
                text: 'Mutual Funds'
            },
            children: [{
                    name: 'Raw Data',
                    url: '/mutual-funds/rawdata',
                    icon: 'fa fa-building',
                },
                {
                    name: 'All Scheme Analysis',
                    url: '/mutual-funds/all-scheme-analysis',
                    icon: 'fa fa-list',
                },
                {
                    name: 'Scheme',
                    url: '/mutual-funds/scheme',
                    icon: 'fa fa-sitemap',
                },
                {
                    name: 'Consolidated Portfolio',
                    url: '/mutual-funds/portfolio',
                    icon: 'fa fa-briefcase',
                },
                {
                    name: 'Themes',
                    url: '/mutual-funds/themes',
                    icon: 'fa fa-money',
                    // badge: {
                    //   variant: 'Themes',
                    //   text: 'Themes'
                    // },
                    // children: [
                    //   {
                    //     name: 'Schemes',
                    //     url: '/mutual-funds/themes/schemes',
                    //     icon: 'fa fa-briefcase',
                    //   },
                    // ]
                },
                {
                    name: 'Portfolio',
                    url: '/mutual-funds/mf-portfolio',
                    icon: 'fa fa-briefcase',
                },
                {
                    name: 'Users',
                    url: '/mutual-funds/acl/users',
                    icon: 'fa fa-briefcase',
                },
                {
                    name: 'Recommended Variable',
                    url: '/mutual-funds/variable/mf-variable',
                    icon: 'fa fa-building',
                },
                {
                    name: 'Mutual-fund History',
                    url: '/mutual-funds/reports/mf-history',
                    icon: 'fa fa-list',
                }
            ]
        },
        {
            name: 'Companies',
            url: '/companies',
            icon: 'fa fa-industry',
        },
        {
            name: 'Raw Data',
            url: '/rawdata',
            icon: 'fa fa-building',
        },
        {
            name: 'Overall Raw Data',
            url: '/overall-rawdata',
            icon: 'fa fa-building',
        },
        {
            name: 'Derivative Raw Data',
            url: '/derivative-rawdata',
            icon: 'fa fa-building',
        },
        {
            name: 'Analysis',
            url: '/analysis',
            icon: 'fa fa-list',
            badge: {
                variant: 'info',
                text: 'NEW'
            },
            children: [{
                    name: 'Company Prices Graph',
                    url: '/company-prices-graph',
                    icon: 'fa fa-building',
                },
                {
                    name: 'Company Volume Graph',
                    url: '/company-volume-graph',
                    icon: 'fa fa-building',
                },
                {
                    name: 'Price Analysis',
                    url: '/company-price-analysis',
                    icon: 'fa fa-building',
                },
                {
                    name: 'All Company Price Analysis',
                    url: '/all-company-price-analysis',
                    icon: 'fa fa-building',
                },
                {
                    name: 'Growth Analysis',
                    url: '/growth-analysis',
                    icon: 'fa fa-building',
                },
            ]
        },
        {
            name: 'Sector Data',
            url: '/sector-data',
            icon: 'fa fa-list',
            badge: {
                variant: 'info',
                text: 'NEW'
            },
            children: [{
                    name: 'Industry',
                    url: '/industries',
                    icon: 'fa fa-building'
                },
                {
                    name: 'Sector Sales',
                    url: '/sector-sales',
                    icon: 'fa fa-building'
                },
                {
                    name: 'Percentile Ratios',
                    url: '/yearwise-percentile-ratios',
                    icon: 'fa fa-building'
                },
            ]
        },
        {
            name: 'Market',
            url: '/company-data',
            icon: 'fa fa-list',
            badge: {
                variant: 'info',
                text: 'NEW'
            },
            children: [{
                    name: 'Market Info',
                    url: '/market-info',
                    icon: '',
                },
                {
                    name: 'Percentile Ratios',
                    url: '/percentile-ratios',
                    icon: '',
                },
                {
                    name: 'Traling 12 Months Sales',
                    url: '/traling-12-months-sales',
                    icon: '',
                },
                {
                    name: 'Insider Transaction',
                    url: '/insider-transaction',
                    icon: '',
                },
                {
                    name: 'Largest Traded Stocks',
                    url: '/largest-traded-stock',
                    icon: '',
                },
                {
                    name: 'Market Cap',
                    url: '/market-cap',
                    icon: '',
                },
                {
                    name: 'Relative Strength Ranking',
                    url: '/relative-strength-ranking',
                    icon: '',
                },
                {
                    name: 'Relative Strength Measure',
                    url: '/relative-strength-measure',
                    icon: '',
                },
                {
                    name: 'ROE',
                    url: '/roe',
                    icon: '',
                },
                {
                    name: 'Combined Rank Analysis',
                    url: '/combined-rank-analysis',
                    icon: '',
                },
                {
                    name: 'P All',
                    url: '/p-all',
                    icon: '',
                },
                {
                    name: 'P Analysis',
                    url: '/p-analysis',
                    icon: '',
                },
            ]
        },
        {
            name: 'Indices',
            url: '/indices',
            icon: 'fa fa-calculator',
        },
        {
            name: 'Indices Vs Portfolio',
            url: '/indices-vs-portfolio',
            icon: 'fa fa-building',
        },
        {
            name: 'Manual Forms',
            url: '/manual-forms',
            icon: 'fa fa-list',
            badge: {
                variant: 'info',
                text: 'NEW'
            },
            children: [{
                    name: 'Company Data',
                    url: '/company-data-forms',
                    icon: 'fa fa-gear',
                },
                {
                    name: 'P Data',
                    url: '/p-data-forms',
                    icon: 'fa fa-list',
                }
            ]
        },
        {
            name: 'Qualitative Statements',
            url: '/qualitative-statements',
            icon: 'fa fa-calculator',
        },
        {
            name: 'P Score Analysis',
            url: '/p-score-analysis',
            icon: 'fa fa-list',
        },
        {
            divider: true
        },
        {
            name: 'Themes',
            url: '/themes',
            icon: 'fa fa-tachometer',
            badge: {
                variant: 'user info',
                text: 'User Info'
            },
            children: [{
                    name: 'Themes',
                    url: '/themes',
                    icon: 'fa fa-user',
                },
                {
                    name: 'Blog',
                    url: '/themes/blogs',
                    icon: 'fa fa-list',
                },
            ]
        },
        {
            divider: true
        },
        {
            name: 'Portfolios',
            url: '/portfolios',
            icon: 'fa fa-list',
            badge: {
                variant: 'Portfolio',
                text: 'Portfolio'
            },
            children: [{
                name: 'Portfolios',
                url: '/portfolios',
                icon: 'fa fa-list',
            }, {
                name: 'Add Portfolio',
                url: '/portfolios/add',
                icon: 'fa fa-list',
            }, ]
        },
        {
            divider: true
        },
        {
            name: 'ACL',
            url: '/acl',
            icon: 'fa fa-user',
            badge: {
                variant: 'user info',
                text: 'User Info'
            },
            children: [
                //   {
                //   name: 'Add User',
                //   url: '/user/add-user',
                //   icon: 'fa fa-user',
                // },
                {
                    name: 'Users',
                    url: '/acl/users',
                    icon: 'fa fa-list',
                },
                {
                    name: 'Roles',
                    url: '/acl/roles',
                    icon: 'fa fa-list',
                }
            ]
        },
        {
            divider: true
        },
        {
            name: 'Frontend Settings',
            url: '/settings/frontend',
            icon: 'fa fa-gears',
        },
        {
            divider: true
        },
        {
            name: 'Activity',
            url: '/activity-logs',
            icon: 'fa fa-user',
            badge: {
                variant: 'activity-logs',
                text: 'Activity Logs'
            },
            children: [{
                    name: 'User Activity',
                    url: '/activity-logs/user-activity',
                    icon: 'fa fa-list',
                }, {
                    name: 'Download History',
                    url: '/activity-logs/download-history',
                    icon: 'fa fa-download',
                },
                {
                    name: 'Cron Status',
                    url: '/activity-logs/cron-status',
                    icon: 'fa fa-list',
                },
                {
                    name: 'Cron Time Analysis',
                    url: '/activity-logs/cron-time-analysis',
                    icon: 'fa fa-list',
                },
                {
                    name: 'Data Discrepancy',
                    url: '/activity-logs/data-discrepancy',
                    icon: 'fa fa-list',
                },
            ]
        },
        {
            divider: true
        },
        {
            name: 'Reports',
            url: '/reports',
            icon: 'fa fa-newspaper-o',
            badge: {
                variant: 'report section',
                text: 'Report Rection'
            },
            children: [{
                    name: 'Trending Company',
                    url: '/reports/trending-company',
                    icon: 'fa fa-industry',
                },
                {
                    name: 'Capitaline API',
                    url: '/reports/capitaline-apis',
                    icon: 'fa fa-list',
                },
                {
                    name: 'SMA API',
                    url: '/reports/sma-apis',
                    icon: 'fa fa-list',
                },
                {
                    name: 'Corporate Action',
                    url: '/reports/corporate-action',
                    icon: 'fa fa-list',
                },
                {
                    name: 'User Feedback',
                    url: '/reports/user-feedback',
                    icon: 'fa fa-list',
                },
                {
                    name: 'newsletter-subscription',
                    url: '/reports/newsletter-subscription',
                    icon: 'fa fa-list',
                },
            ]
        },
        {
            divider: true
        },
        {
            name: 'Metabase',
            url: '/metabase/report',
            icon: 'fa fa-file-word-o',
            class: 'mt-auto',
            variant: 'success'
        },
        // {
        //   divider: true
        // },
        // {
        //   name: 'Metabase',
        //   url: 'http://metabase.infini.work/',
        //   icon: 'fa fa-file-word-o',
        //   class: 'mt-auto',
        //   variant: 'success'
        // },
        // {
        //   name: 'Themes',
        //   url: '/themes',
        //   icon: 'fa fa-layout',
        // },
        // {
        //   title: true,
        //   name: 'UI elements',
        //   class: '',
        //   wrapper: {
        //     element: '',
        //     attributes: {}
        //   }
        // },

        // {
        //   name: 'Components',
        //   url: '/components',
        //   icon: 'fa fa-puzzle-piece',
        //   children: [
        //     {
        //       name: 'Buttons',
        //       url: '/components/buttons',
        //       icon: 'fa fa-puzzle-piece',
        //       badge: {
        //         variant: 'danger',
        //         text: 'NEW'
        //       }
        //     },
        //     {
        //       name: 'Badges',
        //       url: '/components/badges',
        //       icon: 'fa fa-id-badge'
        //     },
        //     {
        //       name: 'Tabs',
        //       url: '/components/tabs',
        //       icon: 'fa fa-bars'
        //     },
        //     {
        //       name: 'Social Buttons',
        //       url: '/components/socials',
        //       icon: 'fa fa-share-square-o',
        //       badge: {
        //         variant: 'success',
        //         text: 'NEW'
        //       }
        //     },
        //     {
        //       name: 'Cards',
        //       url: '/components/cards',
        //       icon: 'fa fa-id-card-o'
        //     },
        //     {
        //       name: 'Alerts',
        //       url: '/components/alerts',
        //       icon: 'fa fa-exclamation-triangle'
        //     },
        //     {
        //       name: 'Progress Bars',
        //       url: '/components/progressbars',
        //       icon: 'fa fa-spinner'
        //     },
        //     {
        //       name: 'Modals',
        //       url: '/components/modals',
        //       icon: 'fa fa-fire'
        //     },
        //     {
        //       name: 'Grids',
        //       url: '/components/grids',
        //       icon: 'fa fa-th'
        //     },
        //     {
        //       name: 'Typography',
        //       url: '/components/typography',
        //       icon: 'fa fa-file-word-o'
        //     }
        //   ]
        // },
        // {
        //   name: 'Tables',
        //   url: '/components/tables',
        //   icon: 'fa fa-table'
        // },
        // {
        //   name: 'Forms',
        //   url: '/forms',
        //   icon: 'fa fa-pencil-square-o',
        //   children: [
        //         {
        //             name: 'Basic Form',
        //             url: '/components/basic-form',
        //             icon: 'fa fa-pencil-square-o',
        //             badge: {
        //               variant: 'warning',
        //               text: 'NEW'
        //             }
        //         },
        //         {
        //             name: 'Advanced Form',
        //             url: '/components/advanced-form',
        //             icon: 'fa fa-pencil-square-o',
        //         },
        //         {
        //             name: 'Form Wizard',
        //             url: '/components/wizard-form',
        //             icon: 'fa fa-pencil-square-o',
        //             badge: {
        //               variant: 'danger',
        //               text: 'NEW'
        //             }
        //         }

        //   ]
        // },
        // {
        //   name: 'Icons',
        //   url: '/components/icons',
        //   icon: 'fa fa-star',
        // },
        // {
        //   name: 'Widgets',
        //   url: '/components/widgets',
        //   icon: 'fa fa-calculator',
        //   badge: {
        //     variant: 'info',
        //     text: '60+'
        //   }
        // },
        // {
        //   name: 'Charts',
        //   url: '/components/charts',
        //   icon: 'fa fa-pie-chart',
        //   badge: {
        //     variant: 'info',
        //     text: 'NEW'
        //   },
        //   children: [
        //               {
        //                 name: 'Chart JS',
        //                 url: '/components/chartjs',
        //                 icon: 'fa fa-line-chart'
        //               },
        //               {
        //                 name: 'Flot Chart',
        //                 url: '/components/flotchart',
        //                 icon: 'fa fa-line-chart'
        //               },
        //               {
        //                 name: 'Peity Chart',
        //                 url: '/components/peitychart',
        //                 icon: 'fa fa-line-chart'
        //               },

        //     ]
        // },
        // {
        //   name: 'Maps',
        //   url: '/components/maps/',
        //   icon: 'fa fa-map-marker',
        //   badge: {
        //     variant: 'info',
        //     text: 'NEW'
        //   },
        //   children: [
        //               {
        //                 name: 'Google Maps',
        //                 url: '/components/maps/google-maps',
        //                 icon: 'fa fa-map-o'
        //               },
        //               {
        //                 name: 'Bubble Maps',
        //                 url: '/components/maps/bubble-maps',
        //                 icon: 'fa fa-globe'
        //               },
        //               {
        //                 name: 'Leaflet Maps',
        //                 url: '/components/maps/leaflet-maps',
        //                 icon: 'fa fa-street-view'
        //               },
        //               {
        //                 name: 'Line Maps',
        //                 url: '/components/maps/line-maps',
        //                 icon: 'fa fa-map-signs'
        //               },
        //   ]
        // },
        // {
        //   divider: true
        // },
        // {
        //   title: true,
        //   name: 'Extras'
        // },
        // {
        //   name: 'Pages',
        //   url: '/auth',
        //   icon: 'fa fa-paperclip',
        //   children: [
        //     {
        //       name: 'Login',
        //       url: '/auth/login',
        //       icon: 'fa fa-sign-in'
        //     },
        //     {
        //       name: 'Register',
        //       url: '/auth/register',
        //       icon: 'fa fa-sign-in'
        //     },
        //     {
        //       name: 'Error 404',
        //       url: '/auth/Page404',
        //       icon: 'fa fa-paper-plane'
        //     },
        //     {
        //       name: 'Error 500',
        //       url: '/auth/Page500',
        //       icon: 'fa fa-paper-plane'
        //     }
        //   ]
        // },
        // {
        //   name: 'Documentation',
        //   url: 'http://vuejsadmin.com/documentation/',
        //   icon: 'fa fa-file-text-o',
        //   variant: 'danger'
        // },
        // {
        //   name: 'Purchase',
        //   url: 'https://themeforest.net/item/basix-admin-vuejs-bootstrap-admin-dashboard-template/20838455',
        //   icon: 'fa fa-shopping-cart',
        //   class: 'mt-auto',
        //   variant: 'success'
        // }

    ]
}


// WEBPACK FOOTER //
// ./src/nav.js